/**
 * Maiuscolo globale ("AB" nell'header): regole CSS condivise da TechyWeb e dalle
 * app TL4K incorporate (TL4KAppShell).
 *
 * Perché non basta `text-transform: uppercase` sul wrapper: il foglio dello user
 * agent dà `text-transform: none` a button/select, che quindi non ereditano. Il
 * launcher delle app, "Materiali" e "I miei elaborati" sono pulsanti e restavano
 * in minuscolo. Qui i controlli tornano a ereditare dal genitore.
 *
 * - Selettore dei controlli a specificità zero (`:where`): qualunque regola
 *   d'autore (es. `normal-case`, `textTransform: 'none'`) continua a vincere.
 * - Campi di testo (input testuali, textarea) esclusi: lì si legge ciò che si scrive.
 * - `[data-tl4k-content]` (contenuto degli studenti) non viene mai trasformato.
 */

/** Classe da mettere sul contenitore della UI quando il maiuscolo è attivo. */
export const TL4K_ALL_CAPS_CLASS = 'tl4k-all-caps';

export const TL4K_ALL_CAPS_CSS = `
.${TL4K_ALL_CAPS_CLASS} { text-transform: uppercase; }
:where(.${TL4K_ALL_CAPS_CLASS}) :where(button, select, option, optgroup, input[type="button"], input[type="submit"], input[type="reset"]) { text-transform: inherit; }
.${TL4K_ALL_CAPS_CLASS} [data-tl4k-content] { text-transform: none; }
`;

export function allCapsClassName(enabled: boolean): string | undefined {
  return enabled ? TL4K_ALL_CAPS_CLASS : undefined;
}
